module.exports = __webpack_public_path__ + "static/media/kurultaiCheck.4b3a33c8.png";